import React from 'react';
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, DumbbellIcon } from 'lucide-react';
const stats = [[BookOpenCheckIcon, '350+', 'Pagine tecniche'], [ClipboardListIcon, '60+', 'Sessioni pronte all’uso'], [DumbbellIcon, '150+', 'Esercizi dettagliati'], [CalendarDaysIcon, '6', 'Volumi completi']];
const tags = ['Matwork Classico', 'Reformer', 'Piccoli attrezzi', 'Protocolli clinici', 'Gravidanza e terza età', 'Base · Intermedio · Avanzato'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#38233c] px-5 py-20" data-id="element-250" data-mp="2wsxtrdc9kr2i">
      <div className="mx-auto max-w-6xl text-center" data-id="element-251" data-mp="2srvrenn1vywb">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#241322]" data-id="element-252" data-mp="2ssnfldebiuck">
          Il sistema più completo per le insegnanti di Pilates
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-253" data-mp="2itfyqg8dkhkp">
          PILATES <span className="text-emerald-300" data-id="element-254" data-mp="2dxh5ofc3qbdy">PRONTA</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-255" data-mp="13xn5bqhmrfv8">
          Oltre 350 pagine di piani di lezione, esercizi professionali, disegni
          tecnici e guide cliniche per il tuo Pilates —{' '}
          <strong className="text-white" data-id="element-256" data-mp="z04u1tg54ok2">tutto già fatto per te.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-257" data-mp="yxsc3gadue70">
          {stats.map(([Icon, value, label]) => <div key={label} className="rounded-2xl border border-emerald-300/25 bg-[#241622] p-6" data-id="element-258" data-mp="1rosifxw6ru1u">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-259" data-mp="1crjp4ynbog7h" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-260" data-mp="1cr9w126zdsxk">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-261" data-mp="1hsfpx3cdnm8o">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 rounded-2xl border border-emerald-300/25 bg-[#241622] p-7" data-id="element-262" data-mp="6c8wkmiqysm8">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-263" data-mp="28x387if5gc5e">
            Copertura completa per ogni lezione e ogni allieva
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-264" data-mp="1z8bilgxka3xn">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 rounded-full border border-emerald-300/25 bg-[#38233c] px-4 py-2 text-xs font-bold text-white" data-id="element-265" data-mp="1z5yroe9tsj8g">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-266" data-mp="1pax3bkndjl6x" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}